import React from "react";
import styles from "./Sustainability.module.scss";
import Image from "next/image";
import MinimalCO2SVG from "./MinimalCO2SVG";
import SustainabilityCertificationSVG from "./SustainabilityCertificationSVG";
import WasteConsciousSVG from "./WasteConsciousSVG";
import EthicalSourceSVG from "./EthicalSourceSVG";
import { ComplianceCardsRow } from "../RegulatoryCompliance/RegulatoryCompliance";
import { getCDNImageUrl } from "@/utils/Common";

const complianceData = [
  {
    id: 1,
    text: "Ethical sourcing from audited suppliers",
    icon: EthicalSourceSVG,
  },
  {
    id: 4,
    text: "Waste-conscious fulfillment and packaging",
    icon: WasteConsciousSVG,
  },
  {
    id: 2,
    text: "Minimal CO2 emissions through optimized logistics",
    icon: MinimalCO2SVG,
  },
  {
    id: 3,
    text: "4+ sustainability certification across supplier base",
    icon: SustainabilityCertificationSVG,
  },
];

function Sustainability() {
  return (
    <div className={styles.sustainability}>
      {/* Content and Image  */}
      <div className={styles.contentAndImage}>
        {/* Content */}
        <div className={styles.content}>
          <h6>SUSTAINABILITY</h6>
          <h2>Building a More Sustainable Supply Chain</h2>
          <p>
            Sustainability is not just a value, it’s how we operate. From
            minimizing waste and emissions to responsibly sourcing raw
            materials, we embed planet-first thinking into every step of our
            operations.
          </p>
        </div>
        {/* Image */}
        <div className={styles.imageContainer}>
          <Image
            className={styles.image}
            fill
            alt="sustainability-img"
            src={getCDNImageUrl("sustainability-img.webp")}
          />
        </div>
      </div>
      {/* Impact In Numbers */}
      <div className={styles.impactInNumbersText}>Our Impact</div>
      <ComplianceCardsRow complianceData={complianceData} />
    </div>
  );
}

export default Sustainability;
